import React from 'react';
import HeaderOne from "../common/header/HeaderOne";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import ContactMap from "../components/contact/ContactMap";
import ContactForm from "../components/contact/ContactForm";
import FooterOne from "../common/footer/FooterOne";

const ContactPage = () => {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                heading="Contact Us"
                currentPage="Contact Us" 
            />
            <ContactMap />
            <ContactForm />
            <FooterOne />
        </>
    )
}

export default ContactPage;
